import React from "react";

const EMBLEM = "/ilease-emblem.png";

export const Logo = ({ className = "", size = 34, showText = true, showEmblem = true }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="ilease-logo">
    {showEmblem && (
      <img src={EMBLEM} alt="I-LEASE" style={{ height: size, width: "auto" }} className="object-contain drop-shadow-[0_0_12px_rgba(0,102,255,0.4)]" />
    )}
    {showText && (
      <span className="font-display font-extrabold text-xl tracking-tight leading-none">
        I-LEASE<span className="text-accent ml-1">SRL</span>
      </span>
    )}
  </div>
);
